export const selectCurrency = (state) => state.currency.data;
export const selectLastUpdatedTime = (state) => state.currency.lastUpdatedTime;

